import PageHeader from "../components/PageHeader";
import { useSession } from "../lib/session";
import { firmWords } from "../lib/orgWords";

/**
 * Landing page after login. Intentionally lightweight for v1 — a
 * greeting + pointers into the real work. Later this grows
 * headline stats (active users, open challenges, today's audit
 * events) per-role.
 */
export default function Dashboard() {
  const session = useSession();
  const words = () => firmWords(session.admin());

  return (
    <>
      <PageHeader
        title={session.admin()?.display_name ? `Welcome, ${session.admin()?.display_name}` : "Welcome"}
        subtitle="Noctant admin panel"
      />
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        <div class="card">
          <div class="card-header">
            <h2 class="text-sm font-semibold">Members</h2>
          </div>
          <div class="card-body text-sm text-slate-600">
            Browse the firm's traders and admins. Drill into a member to see
            their {words()?.runs} and role.
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h2 class="text-sm font-semibold">{words()?.area}</h2>
          </div>
          <div class="card-body text-sm text-slate-600">
            Filter by status or user. Reset a {words()?.run} from the detail
            page when a glitch warrants it — the action is audited.
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h2 class="text-sm font-semibold">Operators</h2>
          </div>
          <div class="card-body text-sm text-slate-600">
            Rotate your API key or update your webhook URL. Both actions
            are recorded in the audit log.
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <h2 class="text-sm font-semibold">Audit log</h2>
          </div>
          <div class="card-body text-sm text-slate-600">
            Every admin action + every operator-API call is recorded.
            Filter by actor, action, or target.
          </div>
        </div>
      </div>
    </>
  );
}
